export const ENV = {
    // MODE: 'Test',
    // ALGOLIA_PREFIX: 'test_',
    // VERSION: '1.7.26',
    // FIREBASE_API_URL: 'https://us-central1-retina-test-c5ec5.cloudfunctions.net',
    // FIREBASE_CONFIG:{
    //     apiKey: "AIzaSyDQjUHMAC-6lL23VvyteXAK9VF958APD9w",
    //     authDomain: "retina-test-c5ec5.firebaseapp.com",
    //     databaseURL: "https://retina-test-c5ec5.firebaseio.com",
    //     projectId: "retina-test-c5ec5",
    //     storageBucket: "retina-test-c5ec5.appspot.com",
    //     messagingSenderId: "972873537265"
    // },
    // MODE: 'Staging',
    // ALGOLIA_PREFIX: 'stage_',
    // VERSION: '1.5.15',
    // FIREBASE_API_URL: 'https://us-central1-retina-staging.cloudfunctions.net',
    // FIREBASE_CONFIG:{
    //   apiKey: "AIzaSyDEY-BFkcwCp4cTC0VuWy6uzuso_HRyWMk",
    //   authDomain: "retina-staging.firebaseapp.com",
    //   databaseURL: "https://retina-staging.firebaseio.com",
    //   projectId: "retina-staging",
    //   storageBucket: "retina-staging.appspot.com",
    //   messagingSenderId: "963802493031",
    //   appId: "1:963802493031:web:c6c46403575ed77751e4c2",
    //   measurementId: "G-LJVGC1DTGY"
    // },
    MODE: 'Production',
    ALGOLIA_PREFIX: 'prod_',
    VERSION: '1.7.50',
    FIREBASE_API_URL: 'https://us-central1-retina-47daf.cloudfunctions.net',
    FIREBASE_CONFIG:{
        apiKey: "AIzaSyChjzhnymSTLgx4qM9WO9FWiwTdWQUjV_I",
        authDomain: "retina-47daf.firebaseapp.com",
        databaseURL: "https://retina-47daf.firebaseio.com",
        projectId: "retina-47daf",
        storageBucket: "retina-47daf.appspot.com",
        messagingSenderId: "89955891141"
    },
    // MODE: 'RetinaDirecte',
    // ALGOLIA_PREFIX: 'retine_',
    // VERSION: '1.7.25',
    // FIREBASE_API_URL: 'https://us-central1-retine-directe-test-c5ec5.cloudfunctions.net',
    // FIREBASE_CONFIG:{
    //   apiKey: "AIzaSyDkZCHskxAWKT4a4gHXwvgOHpzRKuSJpLg",
    //   authDomain: "retine-directe.firebaseapp.com",
    //   projectId: "retine-directe",
    //   storageBucket: "retine-directe.appspot.com",
    //   messagingSenderId: "565099254764",
    //   appId: "1:565099254764:web:ad4bb8bf988504774926c9",
    //   measurementId: "G-0L5K578F0J"
    // },
    PROVINCES: [
        // { short: "AB", name: "Alberta", country: "CA" },
        // { short: "BC", name: "British Columbia", country: "CA" },
        // { short: "MB", name: "Manitoba", country: "CA" },
        // { short: "NB", name: "New Brunswick", country: "CA" },
        {
          short: "NL",
          name: "Newfoundland and Labrador",
          country: "CA",
          alt: ["Newfoundland", "Labrador"]
        },
        // { short: "NS", name: "Nova Scotia", country: "CA" },
        // { short: "NU", name: "Nunavut", country: "CA" },
        // { short: "NT", name: "Northwest Territories", country: "CA" },
        { short: "ON", name: "Ontario", country: "CA" },
        // { short: "PE", name: "Prince Edward Island", country: "CA" },
         { short: "QC", name: "Quebec", country: "CA" }
        // { short: "SK", name: "Saskatchewan", country: "CA" },
        // { short: "YT", name: "Yukon", country: "CA" }
      ]
  }


// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts